var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"leftSlide","appear":""}},[_c('div',{staticClass:"drawer"},[_c('list-menu',{staticClass:"drawer__menu",attrs:{"menu-list":_vm.menuList,"font-color":_vm.fontColor,"icon-color":_vm.iconColor,"head-color":_vm.headColor,"hover-color":_vm.hoverColor,"padding":"20px","has-line-campaign-banner":!_vm.isLoggedIn}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586ed6c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/common/Drawer.vue
// module id = null
// module chunks = 